import { useGetUserFullNameWithFallback } from '@pba/react-utils';
import type { ChatRoom } from 'models';
import { useCallback } from 'react';
import { useUser } from 'features/auth';
import { useGetListUserDisplayName } from './useGetListUserDisplayName';

type P = Pick<ChatRoom, 'name' | 'participants' | 'users'>;

export const useGetChatroomName = () => {
  const { nodeUserData: nodeViewer } = useUser();
  const getUserFullNameWithFallback = useGetUserFullNameWithFallback();
  const getListUserDisplayName = useGetListUserDisplayName();

  return useCallback(
    ({ name, participants, users }: P) => {
      if (name) {
        return name;
      }

      const otherUsers = users.filter((userId) => userId !== nodeViewer._id);
      const usersForTitle = otherUsers.length > 0 ? otherUsers : [nodeViewer._id];
      const title = usersForTitle.map((userId) => getUserFullNameWithFallback(participants[userId] ?? {})).join(', ');

      if (otherUsers.length === 0) {
        return getListUserDisplayName(nodeViewer._id, title);
      }

      return title;
    },
    [getListUserDisplayName, getUserFullNameWithFallback, nodeViewer._id],
  );
};
